// src/context/LangContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState('en');
  const isRtl = currentLang === 'ar';

  useEffect(() => {
    document.documentElement.dir  = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;
    document.title = isRtl
      ? 'لواصق للصناعات | حلول الطباعة الرقمية والفليكسو'
      : 'Lawaseq Industries | Digital & Flexo Printing Solutions';
  }, [currentLang, isRtl]);

  return (
    <LangContext.Provider value={{ currentLang, setCurrentLang, isRtl }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within <LangProvider>');
  return ctx;
};
